import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { BenefitsItemModule } from '../benefits-item/benefits-item.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BenefitsItemModule,
  ],
  
})
export class ConversorModule { }